/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, merge, of } from 'rxjs';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import {
    changePasswordErrorAction,
    changePasswordSuccessAction,
    SettingsSecurityAction,
    SettingsSecurityActionType,
} from '../actions/settingsSecurityActions';
import { usersClient } from '../api/users/usersClient';
import { logoutUser, UserAction } from '../actions/userActions';

type ChangePasswordEpic = Epic<SettingsSecurityAction | UserAction>;

export const changeUserPasswordEpic: ChangePasswordEpic = (action$, state) => {
    const changePassword$ = action$.pipe(
        ofType(SettingsSecurityActionType.CHANGE_PASSWORD),
        switchMap((action) => {
            const userId = state.value.userReducer.authData.userId;

            return from(usersClient.changeUserPassword(userId, action.payload)).pipe(
                map(() => changePasswordSuccessAction()),

                catchError((err: AxiosError) =>
                    of(changePasswordErrorAction(parseError(err, i18n.t('SystemScreens.errors.changePasswordFailed')))),
                ),
                takeUntil(action$.ofType(SettingsSecurityActionType.EXIT_SETTINGS_SECURITY_PAGE)),
            );
        }),
    );

    const logoutUserAfterChangePassword = action$.pipe(
        ofType(SettingsSecurityActionType.CHANGE_PASSWORD_SUCCESS),
        map(() => logoutUser()),
    );

    return merge(changePassword$, logoutUserAfterChangePassword);
};
